'use strict';

var React = require('react');
var reactHelmet = require('react-helmet');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var focusVisible = "https://cdn.ownup.com/component-library/v2.1.2/polyfills/focus-visible.min.js";

// See polyfills section of README file for information on how

/**
 * Mapping of Polyfills to their proper import. Note that this is
 *   distinct from the resolved paths in the polyfills config file
 *   these should be your module inputs that will be converted
 *   by rollup.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
var POLYFILL_MAP = {
  'focus-visible': focusVisible
};

/**
 * Names of various polyfill libraries
 */

/**
 * List of all polyfills loaded by this project.
 */
var polyfillNames = Object.keys(POLYFILL_MAP);

/**
 * Create a script tag for the given polyfill so that it
 *   will be loaded from the server's static file directory.
 */
var createPolyfill = function createPolyfill(name) {
  return /*#__PURE__*/React__default['default'].createElement(reactHelmet.Helmet, {
    key: name
  }, /*#__PURE__*/React__default['default'].createElement("script", {
    src: POLYFILL_MAP[name]
  }));
};

/**
 * Element in which to inject polyfills. Polyfills are all
 *   loaded as script elements rather than imported modules,
 *   as we need to ensure they are executed on the client's
 *   browser at the right time.
 *
 * See the polyfill section of the README for more details.
 *
 * @param props - dictates which polyfills to inject or not
 *   inject. Set a polyfill to "false" to prevent it from
 *   being injected. {@see OwnUpPolyfillProperties}
 */
var OwnUpComponentLibraryPolyfills = function OwnUpComponentLibraryPolyfills(polyfillConfig) {
  var polyfillElements = React.useMemo(function () {
    return polyfillNames.reduce(function (acc, polyfill) {
      if (polyfillConfig[polyfill] !== false) {
        acc.push(createPolyfill(polyfill));
      }
      return acc;
    }, []);
  }, [polyfillConfig]);
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, polyfillElements);
};

exports.OwnUpComponentLibraryPolyfills = OwnUpComponentLibraryPolyfills;
//# sourceMappingURL=element-a61cbeb7.js.map
